<div class="d-flex gap-2 align-items-center">
  <div>Quick Filter:</div>
  <mat-chip-listbox class="gap-2 mb-1" multiple>
    <mat-chip-option [selected]="showValid()" (click)="showValid.set(!showValid())">Valid</mat-chip-option>
    <mat-chip-option [selected]="showExpired()" (click)="showExpired.set(!showExpired())">Expired</mat-chip-option>
    <mat-chip-option [selected]="showInvalid()" (click)="showInvalid.set(!showInvalid())">Invalid</mat-chip-option>
  @if (branchIdFilter() !== undefined) {
    <mat-chip  (removed)="branchIdFilter.set(undefined)">Branch Id = {{ branchIdFilter() }}
      <button matChipRemove>
        <svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 5L5 19M5.00001 5L19 19" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
    </mat-chip>
  }
  </mat-chip-listbox>
</div>
<div class="table-responsive shadow">
  <table mat-table [dataSource]="table.dataSource()"  matSort (matSortChange)="table.sortState.set($event)">
    @for (c of table.config(); track c.columnDef) {
      <ng-container [matColumnDef]="c.columnDef">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ c.header }}</th>
        <td mat-cell *matCellDef="let business">
          @if (c.type === "boolean") {
            <mat-checkbox [checked]="business[c.property]" disabled="true"></mat-checkbox>
          } @else {
            @if (c.onClick) {
              <div (click)="c.onClick(business)" class="pointer">{{ table.formatValue(business, c) }}</div>
            } @else {
              {{ table.formatValue(business, c) }}
            }
          }
        </td>
      </ng-container>
    }
    <ng-container matColumnDef="Actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let license" width="180">
      @if (license.Status === LICENSE_STATUS.EXPIRED) {
        <button class="btn" (click)="renewLicense(license)" title="Renew"><i class="fas fa-copy text-secondary"></i></button>
      } @else {
        <button class="btn" (click)="updateLicense(license)" title="Edit"><i class="fas fa-pencil-alt text-secondary"></i></button>
      }
      @if (license.Status === LICENSE_STATUS.INVALID) {
        <button class="btn" (click)="revalidateLicense(license)" title="Revalidate"><i class="fas fa-redo-alt text-success"></i></button>
      } @else {
        <button class="btn" (click)="invalidateLicense(license)" title="Delete"><i class="fas fa-times text-danger"></i></button>
      }
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns()" [ngClass]="{ 'bg-secondary-subtle': row.Status === LICENSE_STATUS.EXPIRED, 'bg-body-tertiary text-dark text-opacity-75': row.Status === LICENSE_STATUS.INVALID, 'bg-m3-primary-subtle': row.Status === LICENSE_STATUS.EXPIRING }"></tr>
  </table>
</div>
